import '../../resources/css/login/ModalForgotPwd.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Modal} from 'react-bootstrap';
import { forwardLogin } from '../../actions/login/index';
import ForgotPwdForm from './ForgotPwdForm';

class ModalForgotPwd extends Component {
  constructor(props) {
    super(props);

    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    const { forwardLogin } = this.props;
    forwardLogin(null);
  }

  render() {
    const { show } = this.props;
    
    return (
      <Modal
        show={show}
        dialogClassName="modal-forgot-pwd"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={this.closeModal}
      >
        <Modal.Header closeButton >
          <Modal.Title id="deviceStatusTitle">
            Forgot Password
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm={2} ml={3}>&nbsp;</Col>
            <Col sm={8} ml={6}><ForgotPwdForm></ForgotPwdForm></Col>
            <Col sm={2} ml={3}>&nbsp;</Col>
          </Row>
        </Modal.Body>
      </Modal>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.logindReducers.showForgotPwd
  }
}

export default connect(
  mapStateToProps,
  { forwardLogin }
)(ModalForgotPwd)